import ImageWithFallback from 'commons-basic-components/components/ImageWithFallback/ImageWithFallback.jsx';
import LoaderAnim from 'commons-basic-components/components/LoaderAnim/LoaderAnim.jsx';
import MessageBox from 'commons-basic-components/components/MessageBox/MessageBox.jsx';
import PreviewPhoto from 'commons-basic-components/components/PreviewPhoto/PreviewPhoto.jsx';
import Tooltip from 'commons-basic-components/components/Tooltip/Tooltip.jsx';

export { ImageWithFallback, LoaderAnim, MessageBox, PreviewPhoto, Tooltip };

export default {
    ImageWithFallback,
    LoaderAnim,
    MessageBox,
    PreviewPhoto,
    Tooltip,
};
